export const black_overlay50 = 'rgba(0, 0, 0, 0.5)';

export const gray20 = '#F3F3F3';

export const gray40 = '#DBDBDB';

export const gray60 = '#B3B3B3';

export const gray80 = '#757575';

export const gray100 = '#000000';

export const white = '#FFFFFF';

export const white_overlay30 = 'rgba(255, 255, 255, 0.3)';

export const white_overlay80 = 'rgba(255, 255, 255, 0.8)';

export const orange50 = '#F03C0A';

export const orange30 = '#F3633B';

export const orange20 = '#FBC4B5';

export const orange_overlay30 = 'rgba(240, 60, 10, 0.3)';

export const orange_overlay20 = 'rgba(240, 60, 10, 0.2)';

export const red90 = '#760311';

export const red50 = '#BD0017';

export const red20 = '#FFEBEB';

export const blue90 = '#0C6394';

export const blue50 = '#0A7EBF';

export const blue20 = '#EBFAFF';

export const green50 = '#4CAF50';

export const primaryButtonBackgroundColor = {
  '&:disabled': {
    backgroundColor: orange20,
    color: white,
  },
  '&:hover': {
    backgroundColor: orange30,
    boxShadow: 'none',
    color: white,
  },
  backgroundColor: orange50,
  boxShadow: 'none',
  color: white,
};

export const secondaryButtonBackgroundColor = {
  '&:disabled': {
    backgroundColor: white,
    border: `1px solid ${orange20}`,
    color: orange20,
  },
  '&:hover': {
    backgroundColor: white,
    border: `1px solid ${orange30}`,
    boxShadow: 'none',
    color: orange30,
    opacity: '80%',
  },
  backgroundColor: white,
  border: `1px solid ${orange50}`,
  boxShadow: 'none',
  color: orange50,
};

export const tertiaryButtonBackgroundColor = {
  '&:disabled': {
    backgroundColor: white,
    border: `1px solid ${gray40}`,
    color: gray40,
  },
  '&:hover': {
    backgroundColor: white,
    border: `1px solid ${gray60}`,
    boxShadow: 'none',
    color: gray60,
    opacity: '80%',
  },
  backgroundColor: white,
  border: `1px solid ${gray80}`,
  boxShadow: 'none',
  color: gray80,
};

export const tertiaryButtonBackgroundColorWhiteOverlay80 = {
  '&:disabled': {
    backgroundColor: white_overlay80,
    border: `none`,
    color: gray40,
  },
  '&:hover': {
    border: `none`,
    boxShadow: 'none',
    color: gray60,
    opacity: '80%',
  },
  border: `none`,
  boxShadow: 'none',
  color: gray80,
};

export const buttonTextIconLarge = {
  fontSize: '16px',
  fontWeight: 700,
};
